import { useState, useEffect } from 'react';

interface WindowDimentions {
    innerWidth: number;
    innerHeight: number;
}

function getWindowDimensions(): WindowDimentions {
    const { innerWidth, innerHeight } = window;

    return {
        innerWidth,
        innerHeight
    };
  }
  
  const useWindowDimensions = (): WindowDimentions =>  {
    const [windowDimensions, setWindowDimensions] = useState<WindowDimentions>(
      getWindowDimensions()
    );
  
    useEffect(() => {
      const handleResize = (): void => {
        setWindowDimensions(getWindowDimensions());
      }
  
      window.addEventListener('resize', handleResize);

      return (): void => window.removeEventListener('resize', handleResize);
    }, []);
  
    return windowDimensions;
  }

  export default useWindowDimensions;